<template>
    <div class="box">
        <h2>
            {{title}}
        </h2>
        <ul>
            <li v-for="(item,i) in list" v-if="i<5">
                <a :href="'/product-item/'+item"><span>{{item}}</span></a>
            </li>
            <li v-if="list.length>5">
                <a :href="'/product/'+id" ><span style="font-size:14px;color:#2d2d2d">更多</span></a>
            </li>
        </ul>
        <img :src="src"/>
    </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['list', 'src', 'title', 'id']
}
</script>
<style scoped>
    .box{
        width: 275px;
        height: 305px;
        background-color: #f0f0f0;
        position: relative;
        float:left;
        margin-right: 35px;
    }
    .box:last-child{
        margin-right: 0px;
    }

    .box h2{
        font-weight:normal;
        line-height: 70px;
        margin-left:30px;
        font-size: 30px;
        margin-bottom: 0px;
        color:#10499f;
        margin-top:0px;
        padding: 0px;
    }

    .box img{
        position:absolute;
        height:95px;
        right: 30px;
        bottom: 30px;
    }

    ul{
        padding:0px;
        margin: 0px;
        margin-left: 30px;
    }

    .box li{
        font-size: 16px;
        color: #000000;
        line-height: 36px;;
        height: 36px;
        list-style: none;
        position: relative;
    }

    .box li a{
        text-decoration: none;

    }

    .box li a span{
        color: #000000;
    }

    .box li a span:after{
        content: "";
        position: absolute;
        margin-left: 10px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 6px;
        border-color: transparent transparent transparent #7f7f7f;
        top: 30%;
    }

    .box li a:hover span{
        color: #FBAE38;
    }

    .box li a:hover span:after{
        border-color: transparent transparent transparent #FBAE38;
        -webkit-animation: linkGo .5s alternate infinite ease-in both;
        animation: linkGo .5s alternate infinite ease-in both;
    }

    .box li a:hover span:after{
        color: #FBAE38;
    }

    @-moz-keyframes linkGo {
        0% {
            top: 50%;
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            transform: translateX(5px) translateY(-50%);
        }
    }

    @-o-keyframes linkGo {
        0% {
            top: 50%;
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            transform: translateX(5px) translateY(-50%);
        }
    }

    @-webkit-keyframes linkGo {
        0% {
            top: 50%;
            -webkit-transform: translateX(0px) translateY(-50%);
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            -webkit-transform: translateX(5px) translateY(-50%);
            transform: translateX(5px) translateY(-50%);
        }
    }

    @keyframes linkGo {
        0% {
            top: 50%;
            -webkit-transform: translateX(0px) translateY(-50%);
            transform: translateX(0px) translateY(-50%);
        }

        100% {
            top: 50%;
            -webkit-transform: translateX(5px) translateY(-50%);
            transform: translateX(5px) translateY(-50%);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/base/index-product-item.vue